import { css, SerializedStyles } from '@emotion/core';
import { shadowTop, Theme } from 'features/Theme';

const styles = {
  notPinnedFooter: css`
    ${shadowTop()};
  `,

  container: (theme: Theme): SerializedStyles => css`
    position: sticky;
    bottom: -1px;
    padding-left: ${theme.mui.spacing(2)}px;
    padding-right: ${theme.mui.spacing(2)}px;
    margin-left: -${theme.mui.spacing(2)}px;
    margin-right: -${theme.mui.spacing(2)}px;
    width: 100%;
    background-color: ${theme.mui.palette.common.white};
  `,
};

export default styles;
